import { computed, effect, Injectable } from "@angular/core";
import { toSignal } from "@angular/core/rxjs-interop";
import { BaseStore } from "@malirang/front-share";
import { map } from "rxjs";
import { menus } from "../app/layout/const/menus";

export interface IMenu {
    name: string;
    href?: string;
    children?: IMenu[];
    icon?: string;
    description?: string;
    queryParams?: any;
    hidden?: boolean;
    modal?: any;
}

type State = {
    menus: IMenu[];
    path: string;
};

@Injectable({ providedIn: "root" })
export class LayoutStore extends BaseStore<State> {
    menus$ = this.state$.pipe(map((state) => state.menus));
    path$ = this.state$.pipe(map((state) => state.path));

    menus = toSignal(this.menus$);
    path = toSignal(this.path$);

    currentMenu = computed<IMenu | undefined>(() => {
        const currentPath = this.path();
        return this.menus()?.find((menu) => {
            if (menu.children) {
                return menu.children.some((child) => {
                    const childHref = child.href ?? "";

                    // 절대 경로와 상대 경로 모두 처리
                    if (childHref.startsWith("/")) {
                        return (
                            currentPath === childHref ||
                            currentPath?.startsWith(childHref + "/")
                        );
                    } else {
                        return currentPath?.includes("/" + childHref);
                    }
                });
            }

            const menuHref = menu.href ?? "";
            if (menuHref.startsWith("/")) {
                return (
                    currentPath === menuHref ||
                    currentPath?.startsWith(menuHref + "/")
                );
            } else {
                return currentPath?.includes("/" + menuHref);
            }
        });
    });

    currentChildMenu = computed<IMenu | undefined>(() => {
        const currentMenu = this.currentMenu();
        const currentPath = this.path();

        if (currentMenu?.children) {
            return currentMenu.children.find((child) => {
                const childHref = child.href ?? "";

                // 절대 경로와 상대 경로 모두 처리
                if (childHref.startsWith("/")) {
                    return (
                        currentPath === childHref ||
                        currentPath?.startsWith(childHref + "/")
                    );
                } else {
                    return currentPath?.includes("/" + childHref);
                }
            });
        }

        return undefined;
    });

    constructor() {
        super({
            menus: [],
            path: "",
        });
    }

    setPath(path: string) {
        this.updateState({ path });
    }

    setMenus(menus: IMenu[]) {
        this.updateState({ menus });
    }
}
